module.exports = __webpack_public_path__ + "static/img/ourBanner.b24ad7d.png";


//////////////////
// WEBPACK FOOTER
// ./static/ourBanner.png
// module id = tbLv
// module chunks = 1